// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1353":"5d87480b","4780":"5d87480b"}[chunkId] + ".chunk.css";
};